import { render, staticRenderFns } from "./ProductActivities.vue?vue&type=template&id=58e3f835&scoped=true"
import script from "./ProductActivities.vue?vue&type=script&lang=js"
export * from "./ProductActivities.vue?vue&type=script&lang=js"
import style0 from "./ProductActivities.vue?vue&type=style&index=0&id=58e3f835&prod&scoped=true&lang=css"
import style1 from "./ProductActivities.vue?vue&type=style&index=1&id=58e3f835&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e3f835",
  null
  
)

export default component.exports